import styled from '@emotion/styled'

import { WithTheme } from './../../../setup/index'
import media from './../../../common/MediaQueries'

const CtaStyled = styled.div<WithTheme>`
  background-color: ${({ theme }) => theme.colors.grayLight};

  width: 100%;

  padding: 3.375rem 0;
  border-radius: 0.3125rem;

  @media ${media.phone} {
    padding: 2.125rem 0;
  }
`
const CtaContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  max-width: 61.25rem;
  width: 100%;
  margin: 0 auto;
  padding: 0 1.5rem;

  @media ${media.maxPhone} {
    align-items: center;
  }

  @media ${media.phone} {
    flex-direction: row;
  }
`

const CtaContentStyled = styled.div`
  @media ${media.maxPhone} {
    margin-bottom: 2rem;
  }
  @media ${media.phone} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-left: 3.125rem;' : 'padding-right: 3.125rem;')}
  }
  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-left: 5rem;' : 'padding-right: 5rem;')}
  }
`

const CtaContentTitleStyled = styled.div`
  margin-bottom: 0.375rem;
  @media ${media.maxPhone} {
    text-align: center;
  }
`

const CtaContentSubtitleStyled = styled.div`
  @media ${media.maxPhone} {
    text-align: center;
  }
`

const CtaButtonStyled = styled.div``

export { CtaStyled, CtaContainerStyled, CtaContentStyled, CtaContentTitleStyled, CtaContentSubtitleStyled, CtaButtonStyled }
